import { uploadStatusActions } from '@constants/actionTypes';

const defaultState = {
  timeSavedLast: null,
  isInitializing: true,
  data: null,
  newlyCompletedDocsCount: 0,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case uploadStatusActions.receiveData: {
      const { data, timeStart } = action.payload;
      if (state.timeSavedLast !== null && state.timeSavedLast.isAfter(timeStart)) {
        return state;
      }
      return {
        ...state,
        timeSavedLast: timeStart,
        isInitializing: false,
        data,
        newlyCompletedDocsCount:
          state.newlyCompletedDocsCount + data.completed.length - (state.data?.completed?.length || 0),
      };
    }

    case uploadStatusActions.clearNewlyCompletedUploadDocsCount: {
      return {
        ...state,
        newlyCompletedDocsCount: 0,
      };
    }

    default:
      return state;
  }
}
